// ZoomSlider.js
export default class Title {
    constructor(map) {
        this.map = map
        this.scale = document.querySelector('.title-box p')
        this.scales = {
            0: "1:320,000,000", 1: "1:160,000,000", 2: "1:80,000,000", 3: "1:40,000,000",
            4: "1:20,000,000", 5: "1:10,000,000", 6: "1:5,000,000", 7: "1:2,500,000",
            8: "1:1,250,000", 9: "1:640,000", 10: "1:320,000", 11: "1:160,000", 12: "1:80,000",
            13: "1:40,000", 14: "1:20,000", 15: "1:10,000", 16: "1:5,000", 17: "1:2,500",
            18: "1:1,250", 19: "1:600", 20: "1:300", 21: "1:300", 22: "1:300",
        };

    }

    getScaleFromZoom(zoomlevel) {
        this.scale.innerHTML =  this.scales[Math.floor(zoomlevel)] || "1:320,000,000";
    }
}